import api from './api'
import {
  DjangoTokenPairDto,
  DjangoTokenRefreshDto,
  DjangoLoginRequest,
} from '../types/django'
import { getTenant } from '../utils/tenant';
import { CurrentUserDto } from '../types/django/user' 


/**
 * =========================
 * TENANT HELPERS 
 * 
 * const getTenant = () => {
  const host = window.location.hostname

  if (host === 'localhost' || host === '127.0.0.1') {
    return 'public'
  }

  return host
}
 * =========================
 */



/**
 * =========================
 * STORAGE KEYS
 * =========================
 */
const getAccessKey = () => `access_token_${getTenant()}`
const getRefreshKey = () => `refresh_token_${getTenant()}`
const getUserKey = () => `auth_user_${getTenant()}`


/**
 * =========================
 * SERVICE
 * =========================
 */
export const authService = {

  // LOGIN
  async login(credentials: DjangoLoginRequest): Promise<DjangoTokenPairDto> {
    const response = await api.post<DjangoTokenPairDto>(
      '/token/',
      credentials
    )

    const tokens = response.data
    this.setTokens(tokens)

    return tokens
  },


  // FETCH USER 
  async fetchUser(): Promise<CurrentUserDto> {
    const response = await api.get<CurrentUserDto>('/auth/me/')

    const user = response.data
    localStorage.setItem(getUserKey(), JSON.stringify(user))

    return user
  },


  // REFRESH
  async refreshAccessToken(): Promise<string | null> {
    const refresh = this.getRefreshToken()
    if (!refresh) return null

    try {
      const response = await api.post<DjangoTokenRefreshDto>(
        '/token/refresh/',
        { refresh }
      )

      const { access } = response.data
      localStorage.setItem(getAccessKey(), access)

      return access
    } catch {
      this.clearAuth()
      return null
    }
  },
  // SIGNUP
  async signup(data: {
    name: string
    email: string
    password: string
  }): Promise<{ tenant: { domain: string; schema: string;} }> {

    const response = await api.post('/auth/signup/', data)

    const { tokens, tenant } = response.data

    this.setTokens(tokens)

    return { tenant }
  },


  // LOGOUT
  logout(): void {
    this.clearAuth()
    window.location.href = '/login'
  },


  //  TOKENS
  setTokens(tokens: DjangoTokenPairDto): void {
    localStorage.setItem(getAccessKey(), tokens.access)
    localStorage.setItem(getRefreshKey(), tokens.refresh)
  },

  getAccessToken(): string | null {
    return localStorage.getItem(getAccessKey())
  },

  getRefreshToken(): string | null {
    return localStorage.getItem(getRefreshKey())
  },


  //  USER CACHE (FIX )
  getStoredUser(): CurrentUserDto | null {
    try {
      const raw = localStorage.getItem(getUserKey())
      return raw ? JSON.parse(raw) as CurrentUserDto : null
    } catch {
      return null
    }
  },


  isLoggedIn(): boolean {
    return !!this.getAccessToken()
  },


  // CLEAR
  clearAuth(): void {
    localStorage.removeItem(getAccessKey())
    localStorage.removeItem(getRefreshKey())
    localStorage.removeItem(getUserKey())
  },
}